<div class="container-fluid">

    <h4 id="upper">tep/ programme ({{projetData.length}})</h4>
    <div class="d-flex justify-content-end align-items-center flex-wrap gap-3">

        <!-- Ajout des champs de date -->
        <div class="d-flex align-items-center">
            <label class="d-flex align-items-center me-3">
                Début:
                <input disabled type="date" class="form-control ms-2" [(ngModel)]="dateDebut" name="dateDebut">
            </label>
            <label class="d-flex align-items-center">
                Fin:
                <input type="date" class="form-control ms-2" [(ngModel)]="dateFin" name="dateFin">
            </label>
        </div>

        <!-- Bouton Rechercher -->
        <div id="tickets-table_filter" class="dataTables_filter">
            <button (click)="getStatistique()" type="button" class="btn btn-primary">
                <i class="pi pi-search" style="font-size: 0.8rem"></i> Rechercher
            </button>
        </div>

        <!-- Menu Export -->
        <div class="dropdown d-inline-block" ngbDropdown>
            <button type="button" ngbDropdownToggle class="btn btn-secondary dropdown-toggle" id="dropdownMenuButton"
                aria-haspopup="true" aria-expanded="false">
                Exporter <i class="pi pi-upload" style="font-size: 0.8rem"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('pdf')">Au format PDF</a>
                <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('excel')">Au format
                    Excel</a>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-12">
            <div class="card">

                <div class="card-body">

                    <div class="table-responsive mt-3">
                        <table class="table table-bordered table-sm" style="width: 100%;">
                            <thead class="thead-light">
                                <tr>
                                    <th>Programme</th>
                                    <th>Poids (%)</th>
                                    <th>TEP Prévisionnel</th>
                                    <th>TEP Réalisé</th>
                                    <th>Écart</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of paginatedProjets; let index = index">
                                    <td>{{item?.programme.libelle}}</td>
                                    <td>{{item?.programme.poids}}</td>
                                    <td>{{ item?.tep_prevu | number:'1.2-2' }}</td>
                                    <td>{{ item?.tep_realise | number:'1.2-2' }}</td>
                                    <td>{{ (item?.tep_realise - item?.tep_prevu) | number:'1.2-2' }}</td>
                                    <td>
                                        <button class="btn btn-success btn-sm" (click)="detailsProjet(item)">
                                            Détails
                                        </button>
                                    </td>
                                </tr>

                                <tr *ngIf="projetData.length === 0 && isLoading === false">
                                    <td colspan="8">
                                        <div class="row">
                                            <div class="text-center">
                                                <h5 id="graycolor">Aucune donnée trouvée</h5>
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>

                    <div class="d-flex justify-content-center" *ngIf="isLoading === true">
                        <div class="container">
                            <div class="row">
                                <div class="text-center">
                                    <h5 id="graycolor">Chargement en cours</h5>
                                    <!-- <div class="loader4"></div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <p-paginator (onPageChange)="onPageChangeProjets($event)" [first]="firstProjets"
                        [rows]="rowsProjets" [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
                    </p-paginator>
                </div>
            </div>

        </div>

    </div>

    <div class="card">
        <div class="row justify-content-center">

            <div class="col-md-6">
                <div class="card-body">

                    <div *ngIf="projetData && projetData.length > 0; else noData">
                        <p-chart type="bar" [data]="histogramData" [options]="chartOptions" height="400px" width="100%">
                        </p-chart>
                    </div>

                    <ng-template #noData>
                        <div class="text-center p-5">
                            <i class="pi pi-chart-line" style="font-size: 3rem; color: #ccc;"></i>
                            <p class="mt-3 text-muted">Aucune donnée disponible.</p>
                        </div>
                    </ng-template>

                </div>
            </div>

        </div>
    </div>
</div>

<p-confirmDialog />
<p-toast />
<ngx-ui-loader></ngx-ui-loader>